var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_99_45)","key":0},React.createElement("path",{"d":"M28.018 0H6.483C2.902 0 0 2.902 0 6.483V28.016C0 31.598 2.902 34.499 6.483 34.499H28.016C31.598 34.499 34.499 31.598 34.499 28.016V6.483C34.5 2.902 31.598 0 28.018 0ZM28.992 8.088C28.482 7.93 27.853 7.813 27.068 7.813C25.105 7.813 24.283 9.343 24.283 11.227V12.207H28.129V16.602H24.322V31.396H18.318V16.603H15.807V12.208H18.318V11.462C18.318 9.148 19.025 6.595 20.752 5.027C22.242 3.614 24.322 3.104 26.049 3.104C27.383 3.104 28.403 3.262 29.229 3.497L28.992 8.088Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_99_45"},React.createElement("rect",{"width":"34.499","height":"34.499","fill":"white"})))]);
}

Facebook.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
